import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/lazy';
import { Navigation, Autoplay } from 'swiper';

import { ContenedorCarruselesLabs } from '../../../../ui/styles/carruselesLabs.elements';
import './carruselesLabs.css';
import { Link } from 'react-router-dom';
import { useTenantContext } from '../../../../tenant/TenantContext';
import { ManufacturerService } from '../../../../manufacturer/services/ManufacturerService';

function CarouselLabs() {
    const { secondaryColor } = useTenantContext();
    const [labs, setLabs] = useState([]);

    useEffect(() => {
        const getLabs = async () => {
            try {
                setLabs(await ManufacturerService.getAllWithLogo());
            } catch (error) {
                console.error('Error al obtener la lista de fabricantes:', error.message);
            }
        };
        getLabs();
    }, []);

    return (
        <div className="row">
            <div className="col-12 align-self-start">
                <p className="bold text-primary fs-5">FABRICANTES</p>
            </div>

            <ContenedorCarruselesLabs background={secondaryColor}>
                <Swiper
                    dir="ltr"
                    className="mySwiperClientes"
                    modules={[Navigation, Autoplay]}
                    navigation
                    loop={labs.length >= 3}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    speed={600}
                    spaceBetween={24}
                    slidesPerView={6}
                    breakpoints={{
                        0: { slidesPerView: 2, spaceBetween: 16 },
                        480: { slidesPerView: 3, spaceBetween: 18 },
                        780: { slidesPerView: 4, spaceBetween: 20 },
                        1032: { slidesPerView: 4, spaceBetween: 22 },
                        1300: { slidesPerView: 5, spaceBetween: 24 },
                    }}
                    background={secondaryColor}
                >

                    {labs.map((lab) => (
                        <SwiperSlide key={lab.id}>
                            <Link to={`/fabricantes/${lab.id}`} className="labSlideLink" aria-label="Fabricante">
                                <img
                                    src={lab.imageLogo}
                                    alt={`Logo de ${lab.nombre || 'fabricante'}`}
                                    loading="eager"
                                />
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </ContenedorCarruselesLabs>
        </div>
    );
}

export { CarouselLabs };
